import { Injectable } from '@angular/core';
import { createWarning } from '@core/helpers/create-validator.helper';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../../store/revisione53.reducers';

@Injectable()
export class CoopEdilizieWarningsService {
    constructor(private readonly store: Store<Revisione53State>) {}

    my_CkIscrizAlbo = createWarning(this.store, (myVerbale) => {
        const my_CkIscrizAlbo = myVerbale.my_SezioneI__Rilevazione.my_SchedaCoopEdil.my_CkIscrizAlbo;

        if (my_CkIscrizAlbo === '2') {
            return "Le cooperative edilizie iscritte all'albo sono sempre revisionate annualmente";
        } else {
            return null;
        }
    });
}
